import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import Styles from "./ViewModalReceived.module.css";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import Loader from "../../../../commons/Loader/Loader";
import { ReactComponent as SquareIcon } from "../../../../assets/images/view.svg";
import {
  updateStatusConnection,
  acceptBidTerms,
} from "../../../../Services/ApiCalling/banking";
import ViewInjectionModal from "../ViewInjectionModal/ViewInjectionModal";
import ViewDrawalModal from "../ViewDrawalModal/ViewDrawalModal";
import ConnectionAcceptModal from "../../../../commons/PopupModal/BankingPopup/ConnectionAcceptModal/ConnectionAcceptModal";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchMatchmakingResults,
  fetchAllBankingListings,
  compareBothListingDetails,
  fetchActiveLedger,
} from "../../../../Redux/Slices/bankingSlice";
import { getDocumentUrlByLedgerId } from "../../../../Services/ApiCalling/banking";
import SocketService from "../../../../commons/Socket/SocketService";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";

const ViewModalReceived = ({
  open,
  handleClose,
  data,
  refreshConnectionRequests,
  requestsLoading,
  onConnectionAccepted,
  initiatorListing,
  mixedMatches,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const [injectionModalOpen, setInjectionModalOpen] = useState(false);
  const [injectionData, setInjectionData] = useState([]);

  const [drawalModalOpen, setDrawalModalOpen] = useState(false);
  const [drawalData, setDrawalData] = useState([]);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [currentDocumentId, setCurrentDocumentId] = useState(null);
  const [isTermsByPassChecked, setIsTermsByPassChecked] = useState(false);
  const [shouldBypassTerms, setShouldBypassTerms] = useState(false);

  const myListingData =
    data?.source === "PLACED"
      ? data?.bankingListing
      : data?.againstBankingListing;

  const counterpartyListingData =
    data?.source === "PLACED"
      ? data?.againstBankingListing
      : data?.bankingListing;

  const connectLoading = useSelector(
    (state) => state.notificationSlice?.loading || false,
  );

  const formatDateTime = (input) => {
    const date = new Date(input);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const formatEndTime = (timeStr) => {
    if (timeStr === "23:59") return "24:00";
    return timeStr;
  };

  const handleOpenInjectionModal = (slots) => {
    setInjectionData(slots || []);
    setInjectionModalOpen(true);
  };

  const handleOpenDrawalModal = (slots) => {
    setDrawalData(slots || []);
    setDrawalModalOpen(true);
  };

  const handleViewTermsDocument = async (termsDocumentId) => {
    if (!termsDocumentId || termsDocumentId === 0) {
      console.warn("No terms document ID available");
      return;
    }

    try {
      const response = await getDocumentUrlByLedgerId(termsDocumentId);
      const url = response?.data || response;
      if (url) {
        setPreviewFileUrl(url);
        setCurrentDocumentId(termsDocumentId);
        setPreviewModal(true);
      } else {
        console.error("No URL found for terms document");
      }
    } catch (error) {
      console.error("Error viewing terms document:", error);
    }
  };

  const handleChatSetup = (fromName, toName) => {
    const socket = SocketService.getSocket();
    let chatId;

    if (fromName === initiatorListing) {
      chatId = `${fromName?.split("_")?.[0]}_${toName?.split("_")?.[0]}`;
    } else {
      chatId = `${toName?.split("_")?.[0]}_${fromName?.split("_")?.[0]}`;
    }
    socket.emit("create-room", {
      chatId,
      fromUsername: fromName,
      toUsername: toName,
    });
    socket.emit("join-room", { chatId, username: fromName });
  };
  const delay = (ms = 10) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleConfirmStatusUpdate = async () => {
    const fromBanking = data?.bankingListing?.name;
    const toBanking = data?.againstBankingListing?.name;
    setConfirmModalOpen(false);

    if (confirmAction === "DECLINED") {
      setIsLoading(true);
      try {
        const response = await updateStatusConnection(data?.id, 0);
        if (response?.data?.code === 200) {
          await refreshConnectionRequests?.();
          handleClose();
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong");
      } finally {
        setIsLoading(false);
      }
      return;
    }

    if (confirmAction === "ACCEPTED") {
      setIsLoading(true);
      try {
        const listingId1 = data?.bankingListing?.id;
        const listingId2 = data?.againstBankingListing?.id;

        if (!listingId1 || !listingId2) {
          toast.error("Invalid listing details");
          setIsLoading(false);
          return;
        }

        const response = await updateStatusConnection(data?.id, 1);

        if (response?.data?.code === 200) {
          // Run all independent post-accept actions in parallel
          await Promise.all([
            handleChatSetup(fromBanking, toBanking),
            dispatch(fetchMatchmakingResults({ id: listingId1 })),
            dispatch(fetchAllBankingListings()),
            refreshConnectionRequests?.(),
          ]);

          onConnectionAccepted?.(data);

          const isInitiatorTermsByPass =
            data?.bankingListing?.termsByPass === true;
          const isCounterpartyTermsByPass =
            data?.againstBankingListing?.termsByPass === true;

          if (isInitiatorTermsByPass && isCounterpartyTermsByPass) {
            const compareResult = await dispatch(
              compareBothListingDetails({ listingId1, listingId2 }),
            ).unwrap();

            if (compareResult !== true) {
              setIsLoading(false);
              return;
            }

            const basePayload = (listing) => ({
              bankingFactor: listing?.bankingFactor,
              companyName: listing?.companyName,
              connectionId: data?.id,
              gnaepleListing: listing?.gnaepleListing,
              isAccepting: true,
              settlementRate: listing?.settlementRate,
              slotDrawls: listing?.bankingSlotDrawls,
              slotInjects: listing?.bankingSlotInjects,
              userId: listing?.userId,
            });

            await acceptBidTerms(basePayload(data?.bankingListing));
            await acceptBidTerms(basePayload(data?.againstBankingListing));

            await Promise.all([
              dispatch(fetchMatchmakingResults({ id: listingId1 })),
              dispatch(fetchAllBankingListings()),
              dispatch(
                fetchActiveLedger({
                  currentPage: 0,
                  size: 20,
                  bankingListingId: listingId1,
                }),
              ),
              dispatch(
                fetchActiveLedger({
                  currentPage: 0,
                  size: 20,
                  bankingListingId: listingId2,
                }),
              ),
            ]);
          }

          handleClose();
        }
      } catch (error) {
        toast.error(
          error?.message ||
            error?.response?.data?.message ||
            "Something went wrong",
        );
      } finally {
        setIsLoading(false);
      }
    }
  };

  // useEffect(() => {
  //   if (!requestsLoading && isLoading) {
  //     setIsLoading(false);
  //     handleClose();
  //   }
  // }, [requestsLoading, isLoading, handleClose]);

  useEffect(() => {
    const isBothPartiesTermsByPass = async () => {
      if (!data) return false;

      const isInitiatorTermsByPass = data?.bankingListing?.termsByPass === true;
      const isCounterpartyTermsByPass =
        data?.againstBankingListing?.termsByPass === true;

      if (!isInitiatorTermsByPass || !isCounterpartyTermsByPass) {
        return false;
      }

      try {
        const listingId1 = data?.bankingListing?.id;
        const listingId2 = data?.againstBankingListing?.id;

        if (!listingId1 || !listingId2) {
          return false;
        }

        const compareResult = await dispatch(
          compareBothListingDetails({ listingId1, listingId2 }),
        ).unwrap();

        return compareResult === true;
      } catch (error) {
        console.error("Error comparing listings:", error);
        return false;
      }
    };

    const checkTermsByPass = async () => {
      if (open && data && confirmAction === "ACCEPTED") {
        const result = await isBothPartiesTermsByPass();
        setShouldBypassTerms(result);
        setIsTermsByPassChecked(true);
      }
    };
    checkTermsByPass();
  }, [open, data, confirmAction, dispatch]);

  // Add this helper function to get the modal message
  const getConfirmationMessage = () => {
    if (confirmAction === "ACCEPTED") {
      return "Are you sure you want to accept this connection request?";
    }
    return "Are you sure you want to decline this connection request?";
  };

  useEffect(() => {
    const isBothPartiesTermsByPass = async () => {
      if (!data) return false;

      const isInitiatorTermsByPass = data?.bankingListing?.termsByPass === true;
      const isCounterpartyTermsByPass =
        data?.againstBankingListing?.termsByPass === true;

      if (!isInitiatorTermsByPass || !isCounterpartyTermsByPass) {
        return false;
      }

      try {
        const listingId1 = data?.bankingListing?.id;
        const listingId2 = data?.againstBankingListing?.id;

        if (!listingId1 || !listingId2) {
          return false;
        }

        const compareResult = await dispatch(
          compareBothListingDetails({ listingId1, listingId2 }),
        ).unwrap();

        return compareResult === true;
      } catch (error) {
        console.error("Error comparing listings:", error);
        return false;
      }
    };

    const checkTermsByPass = async () => {
      if (open && data && confirmAction === "ACCEPTED") {
        const result = await isBothPartiesTermsByPass();
        setShouldBypassTerms(result);
        setIsTermsByPassChecked(true);
      }
    };
    checkTermsByPass();
  }, [open, data, confirmAction, dispatch]);

  // Add this helper function to get the modal message

  return (
    <>
      <ViewInjectionModal
        open={injectionModalOpen}
        handleClose={() => setInjectionModalOpen(false)}
        data={injectionData}
      />

      <ViewDrawalModal
        open={drawalModalOpen}
        handleClose={() => setDrawalModalOpen(false)}
        data={drawalData}
      />

      {/* <ConnectionAcceptModal
        open={confirmModalOpen}
        handleClose={() => setConfirmModalOpen(false)}
        content={confirmAction === "ACCEPTED" ? "Accept" : "Decline"}
        onConfirm={handleConfirmStatusUpdate}
        actionType={confirmAction}
        insideViewModal={true}
        loading={connectLoading}
      /> */}
      <ConfirmationModal
        open={confirmModalOpen}
        handleClose={() => setConfirmModalOpen(false)}
        header="Confirmation"
        data={getConfirmationMessage()}
        note={
          confirmAction === "ACCEPTED" && shouldBypassTerms
            ? "**You are accepting a 100% matched connection request. Upon acceptance, the listing details will constitute the Final Terms & Conditions, and the parties may proceed directly with documentation.**"
            : null
        }
        handleSubmit={handleConfirmStatusUpdate}
        loading={connectLoading}
      />

      <PreviewModal
        open={previewModal}
        onClose={() => {
          setPreviewModal(false);
          setPreviewFileUrl(null);
          setCurrentDocumentId(null);
        }}
        fileUrl={previewFileUrl}
        documentId={currentDocumentId}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className={Styles.headingText}>Connection Request</div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>

          <div className={`display_flex_row_center ${Styles.tableViewHeading}`}>
            <div
              className={`display_flex_row_center ${Styles.tableViewContentCont}`}
            >
              <div className={`display_flex_row ${Styles.tableArea}`}>
                <div>Category</div>
                <div>My Listing</div>
                <div>Counterparty Listing</div>
              </div>
              {data && (
                <div
                  className={`display_flex_row_center ${Styles.viewTableContent}`}
                >
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Name</div>
                    <div className={Styles.bankingHead}>
                      {counterpartyListingData?.name || "—"}
                    </div>
                    <div className={Styles.bankingHead2}>
                      {myListingData?.name || "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Injection Quantity (MW)</div>
                    <div className={Styles.myQty}>
                      {" "}
                      {counterpartyListingData?.bankingSlotInjects?.[0] ? (
                        <div>
                          {
                            counterpartyListingData.bankingSlotInjects[0]
                              .requiredQty
                          }{" "}
                        </div>
                      ) : (
                        "—"
                      )}
                    </div>
                    <div className={Styles.otherHead}>
                      {" "}
                      {myListingData?.bankingSlotInjects?.[0] ? (
                        <div>
                          {myListingData.bankingSlotInjects[0].requiredQty}{" "}
                        </div>
                      ) : (
                        "—"
                      )}
                    </div>
                  </div>

                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Drawal Quantity (MW)</div>
                    <div className={Styles.myQty}>
                      {" "}
                      {counterpartyListingData?.bankingSlotDrawls?.[0] ? (
                        <div>
                          {
                            counterpartyListingData.bankingSlotDrawls[0]
                              .requiredQty
                          }{" "}
                        </div>
                      ) : (
                        "—"
                      )}
                    </div>
                    <div className={Styles.otherHead}>
                      {" "}
                      {myListingData?.bankingSlotDrawls?.[0] ? (
                        <div>
                          {myListingData.bankingSlotDrawls[0].requiredQty}{" "}
                        </div>
                      ) : (
                        "—"
                      )}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Banking Factor (%)</div>
                    <div className={Styles.myQty}>
                      {counterpartyListingData?.bankingFactor || "—"}
                    </div>
                    <div className={Styles.otherHead}>
                      {myListingData?.bankingFactor || "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Settlement Rate (₹/kWh)</div>
                    <div className={Styles.myQty}>
                      {counterpartyListingData?.settlementRate || "—"}
                    </div>
                    <div className={Styles.otherHead}>
                      {myListingData?.settlementRate || "—"}
                    </div>
                  </div>

                  <div className={` ${Styles.tableViewContent}`}>
                    <div>Injection Date and Time Range</div>

                    <div className={`${Styles.injectDrawalSection}`}>
                      {counterpartyListingData?.bankingSlotInjects?.[0] ? (
                        <div>
                          {
                            counterpartyListingData.bankingSlotInjects[0]
                              .dateStartAt
                          }{" "}
                          to{" "}
                          {
                            counterpartyListingData.bankingSlotInjects[0]
                              .dateEndAt
                          }
                          <br />
                          {
                            counterpartyListingData.bankingSlotInjects[0]
                              .slotStartAt
                          }{" "}
                          to{" "}
                          {formatEndTime(
                            counterpartyListingData.bankingSlotInjects[0]
                              .slotEndAt,
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                      <span
                        className={Styles.spanIconCounter}
                        onClick={() =>
                          handleOpenInjectionModal(
                            counterpartyListingData.bankingSlotInjects,
                          )
                        }
                      >
                        <SquareIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />
                      </span>
                    </div>

                    <div className={`${Styles.injectDrawalSectionCounter}`}>
                      {myListingData?.bankingSlotInjects?.[0] ? (
                        <div>
                          {myListingData.bankingSlotInjects[0].dateStartAt} to{" "}
                          {myListingData.bankingSlotInjects[0].dateEndAt}
                          <br />
                          {
                            myListingData.bankingSlotInjects[0].slotStartAt
                          } to{" "}
                          {formatEndTime(
                            myListingData.bankingSlotInjects[0].slotEndAt,
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                      <span
                        className={Styles.spanIcon}
                        onClick={() =>
                          handleOpenInjectionModal(
                            myListingData.bankingSlotInjects,
                          )
                        }
                      >
                        <SquareIcon style={{ width: "20px", height: "20px" }} />
                      </span>
                    </div>
                  </div>

                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Drawal Date and Time Range</div>

                    <div className={`${Styles.injectDrawalSection}`}>
                      {counterpartyListingData?.bankingSlotDrawls?.[0] ? (
                        <div>
                          {
                            counterpartyListingData.bankingSlotDrawls[0]
                              .dateStartAt
                          }{" "}
                          to{" "}
                          {
                            counterpartyListingData.bankingSlotDrawls[0]
                              .dateEndAt
                          }{" "}
                          <br />
                          {
                            counterpartyListingData.bankingSlotDrawls[0]
                              .slotStartAt
                          }{" "}
                          to{" "}
                          {formatEndTime(
                            counterpartyListingData.bankingSlotDrawls[0]
                              .slotEndAt,
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                      <span
                        className={Styles.spanIconCounter2}
                        onClick={() =>
                          handleOpenDrawalModal(
                            counterpartyListingData.bankingSlotDrawls,
                          )
                        }
                      >
                        <SquareIcon style={{ width: "20px", height: "20px" }} />
                      </span>
                    </div>

                    <div className={`${Styles.injectDrawalSectionCounter}`}>
                      {myListingData?.bankingSlotDrawls?.[0] ? (
                        <div>
                          {myListingData.bankingSlotDrawls[0].dateStartAt} to{" "}
                          {myListingData.bankingSlotDrawls[0].dateEndAt}
                          <br />
                          {
                            myListingData.bankingSlotDrawls[0].slotStartAt
                          } to{" "}
                          {formatEndTime(
                            myListingData.bankingSlotDrawls[0].slotEndAt,
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                      <span
                        className={Styles.spanIcon}
                        onClick={() =>
                          handleOpenDrawalModal(myListingData.bankingSlotDrawls)
                        }
                      >
                        <SquareIcon style={{ width: "20px", height: "20px" }} />
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {showMore && (
                <>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Listing Expiry Date & Time</div>

                    <div style={{ width: "23%" }}>
                      {counterpartyListingData?.expiryAt || "—"}
                    </div>
                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                    >
                      {myListingData?.expiryAt || "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Terms Expiry Date & Time</div>

                    <div style={{ width: "23%" }}>
                      {formatDateTime(counterpartyListingData?.termsExpiryAt) ||
                        "—"}
                    </div>
                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                    >
                      {formatDateTime(myListingData?.termsExpiryAt) || "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Comments</div>

                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                      className={Styles.tableCommentsCell}
                    >
                      {counterpartyListingData?.comments || "—"}
                    </div>
                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                    >
                      {myListingData?.comments || "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Terms and Conditions</div>

                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                      className={Styles.tableCommentsCell}
                    >
                      {counterpartyListingData?.termsDocumentId ? (
                        <span
                          style={{
                            color: "#f1935c",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleViewTermsDocument(
                              counterpartyListingData.termsDocumentId,
                            )
                          }
                        >
                          {/* {counterpartyListingData.termsDocumentId} */}
                          View T&C
                        </span>
                      ) : (
                        "—"
                      )}
                    </div>
                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                    >
                      {myListingData?.termsDocumentId ? (
                        <span
                          style={{
                            color: "#f1935c",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleViewTermsDocument(
                              myListingData.termsDocumentId,
                            )
                          }
                        >
                          {/* {myListingData.termsDocumentId} */}
                          View T&C
                        </span>
                      ) : (
                        "—"
                      )}
                    </div>
                  </div>
                </>
              )}
              <div
                className={`display_flex_row_center ${Styles.viewMoreBtn}`}
                onClick={() => setShowMore((prev) => !prev)}
              >
                {showMore ? "View Less" : "View More"}
              </div>
            </div>
          </div>
          {data?.status === "INITIATED" && data?.source !== "PLACED" && (
            <div
              className={`display_flex_row_center ${Styles.viewModalButtons}`}
            >
              <div
                className={Styles.cancelBankButton}
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              >
                Cancel
              </div>
              <div
                className={`display_flex_row_center ${Styles.viewModalDeclines}`}
                // onClick={() => handleStatusUpdate(data?.id, "DECLINED")}
                onClick={() => {
                  setConfirmAction("DECLINED");
                  setConfirmModalOpen(true);
                }}
              >
                Decline
              </div>
              <div
                className={`display_flex_row_center ${Styles.viewModalAccept}`}
                // onClick={() => handleStatusUpdate(data?.id, "ACCEPTED")}
                onClick={() => {
                  setConfirmAction("ACCEPTED");
                  setConfirmModalOpen(true);
                }}
              >
                Accept
              </div>
            </div>
          )}

          {isLoading && (
            <div className={Styles.loaderOverlay}>
              <Loader />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ViewModalReceived;
